import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
const tag = (value, yes, no, bg, color) => (
  <Chip
    size="small"
    label={value === true ? yes : value === false ? no : "—"}
    sx={{
      bgcolor: value === true ? bg : value === false && yes === "Activo" ? "#fbe7ee" : "#edf1f5",
      color: value === true ? color : value === false && yes === "Activo" ? "#963b59" : "#5b7084",
      fontWeight: 700,
    }}
  />
);

export default function TableWhatsapp({
  configuraciones,
  totalConfiguraciones,
  onEditClick,
  disabled,
}) {
  const [page, setPage] = useState(0),
    [size, setSize] = useState(10);
  useEffect(() => setPage(0), [configuraciones]);
  return (
    <Paper variant="outlined" sx={{ borderRadius: 3, overflow: "hidden" }}>
      <Box sx={{ p: 2.5, bgcolor: "#eef7f3" }}>
        <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#244c42" }}>
          Configuraciones de WhatsApp
        </Typography>
        <Typography sx={{ fontSize: 12, color: "#60798b", mt: 0.5 }}>
          {configuraciones.length} de {totalConfiguraciones} configuraciones
        </Typography>
      </Box>
      <TableContainer>
        <Table
          sx={{
            minWidth: 1150,
            "& th": { bgcolor: "#21594f", color: "#fff", fontWeight: 700, fontSize: 12 },
            "& td": { color: "#29465c", fontSize: 13, borderColor: "#e9eff4" },
            "& tbody tr:nth-of-type(even)": { bgcolor: "#f4f8fb" },
            "& tbody tr.MuiTableRow-hover:hover": { bgcolor: "#e9f4ef" },
          }}
        >
          <TableHead sx={{ display: "table-header-group" }}>
            <TableRow>
              {[
                "Comercio",
                "Terminal",
                "Estado",
                "Grupo NOC",
                "Grupo WhatsApp",
                "Workflow",
                "Pulso",
                "",
              ].map((label) => (
                <TableCell key={label}>{label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {configuraciones.slice(page * size, page * size + size).map((row, index) => (
              <TableRow hover key={`${row.idCommerce}-${row.idTerminal}-${index}`}>
                <TableCell>
                  <Typography sx={{ fontSize: 13, fontWeight: 600, minWidth: 150 }}>
                    {row.nombreComercio}
                  </Typography>
                  <Typography sx={{ fontSize: 12, color: "#6b8396" }}>
                    ID {row.idCommerce}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography sx={{ fontSize: 13 }}>
                    {row.terminalName && row.terminalName !== "Sin terminal"
                      ? row.terminalName
                      : "—"}
                  </Typography>
                  {!!row.idTerminal && (
                    <Typography sx={{ fontSize: 12, color: "#6b8396" }}>
                      ID {row.idTerminal}
                    </Typography>
                  )}
                </TableCell>
                <TableCell>{tag(row.activo, "Activo", "Inactivo", "#def3e8", "#206346")}</TableCell>
                <TableCell>
                  <Chip
                    size="small"
                    label={row.grupoAlertaNOC || "—"}
                    sx={{ bgcolor: "#e4effb", color: "#255b8f", fontWeight: 600 }}
                  />
                </TableCell>
                <TableCell>
                  <Typography
                    sx={{ fontSize: 13, fontWeight: 600, color: "#226750", minWidth: 130 }}
                  >
                    {row.groupName && row.groupName !== "Sin grupo" ? row.groupName : "—"}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Box
                    sx={{
                      p: 0.75,
                      bgcolor: "#eee9fb",
                      color: "#51479c",
                      fontSize: 12,
                      borderRadius: 1.5,
                      maxWidth: 230,
                      fontWeight: 600,
                    }}
                  >
                    {row.workflow || "—"}
                  </Box>
                </TableCell>
                <TableCell>
                  {tag(row.pulso, "Con pulso", "Sin pulso", "#eae6fc", "#51479c")}
                </TableCell>
                <TableCell>
                  <Button
                    variant="outlined"
                    size="small"
                    disabled={disabled}
                    onClick={() => onEditClick(row)}
                    sx={{ "&&": { bgcolor: "#e9f2fb", color: "#245e89", borderColor: "#aac6dc" } }}
                  >
                    Editar
                  </Button>
                </TableCell>
              </TableRow>
            ))}
            {!configuraciones.length && (
              <TableRow>
                <TableCell colSpan={8} align="center" sx={{ py: 5 }}>
                  No hay configuraciones que coincidan con los filtros.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={configuraciones.length}
        page={page}
        rowsPerPage={size}
        onPageChange={(_, value) => setPage(value)}
        onRowsPerPageChange={(e) => {
          setSize(Number(e.target.value));
          setPage(0);
        }}
        rowsPerPageOptions={[10, 25, 50]}
        labelRowsPerPage="Configuraciones por página"
        labelDisplayedRows={({ from, to, count }) => `${from}–${to} de ${count}`}
      />
    </Paper>
  );
}
TableWhatsapp.propTypes = {
  configuraciones: PropTypes.array.isRequired,
  totalConfiguraciones: PropTypes.number.isRequired,
  onEditClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
